<template>
  <div class="mine-container">
    <div class="mine-wrapper">
      <!-- 左侧菜单 -->
      <div class="sidebar">
        <div class="user-info">
          <div class="avatar">
            <img class="avatar-img" :src="userAvatarUrl" alt="头像" />
            <img v-if="userInfo.authStatus === 2" class="auth-icon" src="@/assets/authSuccess.png" alt="已认证" />
          </div>
          <div class="user-name">
            {{ displayName }}
          </div>
          
          <el-button type="danger" plain class="logout-btn" @click="handleLogout">
            退出登录
          </el-button>
        </div>

        <el-menu
          :default-active="activeMenu"
          class="sidebar-menu"
          @select="handleMenuSelect"
        >
          <el-menu-item index="profile">
            <i class="el-icon-user"></i>
            <span>个人信息</span>
          </el-menu-item>
          <el-menu-item index="records">
            <i class="el-icon-document"></i>
            <span>培训记录</span>
          </el-menu-item>
          <el-menu-item index="messages">
            <i class="el-icon-message"></i>
            <span>消息中心</span>
            <span class="badge" v-if="unreadCount > 0">({{ unreadCount }})</span>
          </el-menu-item>
          <el-menu-item index="realName">
            <i class="el-icon-postcard"></i>
            <span>实名认证</span>
            <span class="auth-text" :style="{ color: authStatusColor }">{{ authStatusText }}</span>
          </el-menu-item>
          <el-menu-item index="transfer">
            <i class="el-icon-s-promotion"></i>
            <span>护士转岗</span>
          </el-menu-item>
          <el-menu-item index="invoice">
            <i class="el-icon-tickets"></i>
            <span>开具发票</span>
          </el-menu-item>
          <el-menu-item index="payment">
            <i class="el-icon-wallet"></i>
            <span>缴费记录</span>
          </el-menu-item>
          <el-menu-item index="collection">
            <i class="el-icon-star-off"></i>
            <span>我的收藏</span>
          </el-menu-item>
        </el-menu>
      </div>

      <!-- 右侧内容 -->
      <div class="main-content">
        <h2 class="main-top-title">e护考培智慧培训服务平台</h2>

        <!-- 个人信息 -->
        <div v-if="activeMenu === 'profile'" class="content-section profile-section">
          
          <div
            class="profile-action-center"
            v-if="userInfoLoaded && userInfo.authStatus !== 2"
          >
            <el-button v-if="userInfo.authStatus === 0 || userInfo.authStatus == null" class="auth-btn btn-unauth" @click="$router.push('/realName')">立即认证</el-button>
            <el-button v-else-if="userInfo.authStatus === 1" class="auth-btn btn-auditing" disabled>认证审核中</el-button>
            <el-button v-else-if="userInfo.authStatus === 3" class="auth-btn btn-rejected" @click="$router.push('/realName')">已驳回，请重新认证</el-button>
          </div>

          <div class="profile-info-list centered-info-list">
            <div class="info-row">
              <span class="label">姓名</span>
              <span class="value">{{ userInfo.realName ? userInfo.realName : "--" }}</span>
            </div>
            <div class="info-row">
              <span class="label">手机号码</span>
              <span class="value">{{ userInfo.phone ? userInfo.phone : "--" }}</span>
            </div>
            <div class="info-row">
              <span class="label">身份证号</span>
              <span class="value">{{ userInfo.identity ? userInfo.identity : "--" }}</span>
            </div>
            <div class="info-row">
              <span class="label">所在医院</span>
              <span class="value">{{ hospitalName ? hospitalName : "--" }}</span>
            </div>
          </div>
        </div>

        <!-- 培训记录 -->
        <div v-if="activeMenu === 'records'" class="content-section records-section">
          <div class="training-record-wrapper">
            <el-table
              :data="pagedTrainingRecords"
              v-loading="loading"
              class="training-record-table"
              empty-text="暂无记录"
            >
              <el-table-column label="序号" width="70" align="left">
                <template slot-scope="scope">
                  {{ getRecordIndex(scope.$index) }}
                </template>
              </el-table-column>
              <el-table-column label="培训班名称" min-width="230">
                <template slot-scope="scope">
                  {{ scope.row.name || "--" }}
                </template>
              </el-table-column>
              <el-table-column label="所属专业" min-width="180">
                <template slot-scope="scope">
                  {{ getTrainMajorName(scope.row) }}
                </template>
              </el-table-column>
              <el-table-column label="报名时间" min-width="190">
                <template slot-scope="scope">
                  {{ getApplyEnrollTime(scope.row) }}
                </template>
              </el-table-column>
              <el-table-column label="当前状态" min-width="150">
                <template slot-scope="scope">
                  <span class="record-status-text">
                    {{ getTrainStatusText(scope.row) }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="操作" min-width="210">
                <template slot-scope="scope">
                  <template v-if="getRecordActions(scope.row).length > 0">
                    <el-button
                      v-for="action in getRecordActions(scope.row)"
                      :key="`${scope.row.erId || 'er'}-${action.type}-${action.label}`"
                      size="mini"
                      class="record-action-btn"
                      :class="{
                        'record-action-btn-primary': action.primary,
                        'record-action-btn-disabled': action.disabled
                      }"
                      :disabled="action.disabled"
                      @click="handleRecordAction(action, scope.row)"
                    >
                      {{ action.label }}
                    </el-button>
                  </template>
                  <span v-else class="record-action-empty">--</span>
                </template>
              </el-table-column>
            </el-table>
            <div class="table-pagination" v-if="trainingRecords.length > 0">
              <el-pagination
                background
                :current-page="recordPageNo"
                :page-size="recordPageSize"
                :page-sizes="[5, 10, 20, 50]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="trainingRecords.length"
                @size-change="handleRecordPageSizeChange"
                @current-change="handleRecordPageChange"
              />
            </div>
          </div>
        </div>

        <!-- 消息中心 -->
        <div v-if="activeMenu === 'messages'" class="content-section messages-section">
          <div class="message-wrapper">
            <div class="message-section-header">
              <h3 class="section-title" style="border-bottom: none; margin-bottom: 0; padding-bottom: 0;">消息中心</h3>
              <el-button type="primary" size="small" plain @click="handleReadAllMessages" :loading="markingAllRead">全部已读</el-button>
            </div>
            <div v-if="messages.length === 0" class="empty-tip">暂无消息</div>
            <div v-else class="message-list">
              <div
                v-for="msg in messages"
                :key="msg.umId || msg.id"
                class="message-item"
                :class="{ unread: !msg.isRead }"
                @click="handleViewMessage(msg)"
              >
                <div class="msg-header" style="margin-bottom: 0;">
                  <div class="msg-title">
                    <span v-if="!msg.isRead" class="unread-dot"></span>
                    {{ msg.title }}
                  </div>
                  <div class="msg-time">{{ msg.createTime }}</div>
                </div>
              </div>
            </div>
            <div class="table-pagination" v-if="messageTotalCount > 0">
              <el-pagination
                background
                :current-page="messagePageNo"
                :page-size="messagePageSize"
                :page-sizes="[5, 10, 20, 50]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="messageTotalCount"
                @size-change="handleMessagePageSizeChange"
                @current-change="handleMessagePageChange"
              />
            </div>
          </div>
        </div>

        <el-dialog
          :visible.sync="messageDialogVisible"
          width="600px"
          append-to-body
          custom-class="mine-message-dialog"
          :title="currentMessageTitle"
        >
          <div class="message-dialog-body" v-loading="checkingMessage">
            <div class="msg-content" v-html="currentMessageContent"></div>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="messageDialogVisible = false">关闭</el-button>
          </div>
        </el-dialog>

        <!-- 护士转岗 -->
        <div v-if="activeMenu === 'transfer'" class="content-section transfer-section">
          <div class="transfer-wrapper">
            <div v-if="!isTransferAvailable" class="transfer-auth-tip">
              请先完成实名认证
            </div>
            <div v-else class="transfer-form">
              <div class="transfer-row">
                <div class="transfer-label"><span class="required">*</span>专业：</div>
                <div class="transfer-field">
                  <el-select
                    v-model="transferForm.majorId"
                    filterable
                    placeholder="请选择您的所属专业"
                    :loading="loadingTransferMajorList"
                  >
                    <el-option
                      v-for="major in transferMajorList"
                      :key="major.majorId"
                      :label="major.name"
                      :value="major.majorId"
                    />
                  </el-select>
                </div>
              </div>

              <div class="transfer-row">
                <div class="transfer-label"><span class="required">*</span>医院名称：</div>
                <div class="transfer-field">
                  <el-select
                    v-model="transferForm.hospital"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="请选择医院"
                    :remote-method="loadTransferHospital"
                    :loading="loadingTransferHospital"
                  >
                    <el-option
                      v-for="hos in transferHospitalList"
                      :key="hos.hospital"
                      :label="hos.hospital"
                      :value="hos.hospital"
                    />
                  </el-select>
                  <div class="transfer-hospital-tip">
                    注：如列表中无您的医院，或医院名称有误，请联系工作人员增改，联系电话
                    <span class="transfer-hospital-phone">0531-88951587</span>
                  </div>
                </div>
              </div>

              <div class="transfer-row">
                <div class="transfer-label"><span class="required">*</span>职称：</div>
                <div class="transfer-field">
                  <el-input
                    v-model="transferForm.position"
                    placeholder="请输入您的职称"
                    maxlength="30"
                  />
                </div>
              </div>

              <div class="transfer-row">
                <div class="transfer-label"><span class="required">*</span>医院等级：</div>
                <div class="transfer-field">
                  <el-input
                    v-model="transferForm.hospitalLevel"
                    placeholder="请输入您所在医院的等级"
                    maxlength="30"
                  />
                </div>
              </div>

              <div class="transfer-row">
                <div class="transfer-label"><span class="required">*</span>办公室电话：</div>
                <div class="transfer-field">
                  <el-input
                    v-model="transferForm.officePhone"
                    placeholder="请输入您所在办公室电话"
                    maxlength="30"
                  />
                </div>
              </div>

              <div class="transfer-row transfer-row-upload">
                <div class="transfer-label"><span class="required">*</span>医疗机构执业许可证副本：</div>
                <div class="transfer-field">
                  <el-upload
                    class="transfer-license-upload"
                    action="/file/importPicture"
                    name="pictureFile"
                    accept="image/*"
                    :show-file-list="false"
                    :http-request="handleTransferLicenseUpload"
                    :disabled="submittingTransfer || uploadingTransferLicense"
                  >
                    <img
                      v-if="transferForm.licenseUrl"
                      :src="transferForm.licenseUrl"
                      class="transfer-license-preview"
                      alt="医疗机构执业许可证副本"
                    />
                    <img
                      v-else
                      :src="transferLicensePlaceholder"
                      class="transfer-license-placeholder"
                      alt="医疗机构执业许可证副本占位图"
                    />
                  </el-upload>
                </div>
              </div>

              <div class="transfer-action">
                <el-button
                  type="primary"
                  class="transfer-submit-btn"
                  :loading="submittingTransfer"
                  :disabled="uploadingTransferLicense"
                  @click="handleTransferSubmit"
                >
                  立即转岗
                </el-button>
              </div>
            </div>
          </div>
        </div>

        <!-- 开具发票 -->
        <div v-if="activeMenu === 'invoice'" class="content-section invoice-section">
          <div class="invoice-wrapper">
            <el-table
              :data="pagedInvoiceRecords"
              v-loading="loadingInvoiceRecords"
              class="invoice-record-table"
              empty-text="暂无发票记录"
            >
              <el-table-column label="序号" width="70" align="left">
                <template slot-scope="scope">
                  {{ getInvoiceIndex(scope.$index) }}
                </template>
              </el-table-column>
              <el-table-column label="培训班名称" min-width="220">
                <template slot-scope="scope">
                  {{ getInvoiceExamName(scope.row) }}
                </template>
              </el-table-column>
              <el-table-column label="开票金额" min-width="130">
                <template slot-scope="scope">
                  {{ formatInvoiceAmount(scope.row.realityPayMoney) }}元
                </template>
              </el-table-column>
              <el-table-column label="开票时间" min-width="185">
                <template slot-scope="scope">
                  {{ getInvoiceTimeText(scope.row) }}
                </template>
              </el-table-column>
              <el-table-column label="状态" min-width="180">
                <template slot-scope="scope">
                  <span
                    class="invoice-status-text"
                    :class="{
                      'invoice-status-success': isInvoiceSuccess(scope.row),
                      'invoice-status-fail': isInvoiceFailed(scope.row)
                    }"
                  >
                    {{ getInvoiceStatusText(scope.row) }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="操作" min-width="130">
                <template slot-scope="scope">
                  <el-button
                    v-if="getInvoiceAction(scope.row)"
                    size="mini"
                    class="invoice-action-btn"
                    @click="handleInvoiceAction(scope.row)"
                  >
                    {{ getInvoiceAction(scope.row).label }}
                  </el-button>
                  <span v-else class="record-action-empty">--</span>
                </template>
              </el-table-column>
            </el-table>
            <div class="table-pagination" v-if="showInvoicePagination">
              <el-pagination
                background
                :current-page="invoicePageNo"
                :page-size="invoicePageSize"
                :page-sizes="[10, 20, 50]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="invoiceRecords.length"
                @size-change="handleInvoicePageSizeChange"
                @current-change="handleInvoicePageChange"
              />
            </div>
          </div>
        </div>

        <!-- 缴费记录 -->
        <div v-if="activeMenu === 'payment'" class="content-section payment-section">
          <div class="payment-wrapper">
            <el-table
              :data="pagedPaymentRecords"
              v-loading="loadingPaymentRecords"
              class="payment-record-table"
              empty-text="暂无缴费记录"
            >
              <el-table-column label="序号" width="70" align="left">
                <template slot-scope="scope">
                  {{ getPaymentIndex(scope.$index) }}
                </template>
              </el-table-column>
              <el-table-column label="培训班名称" min-width="240">
                <template slot-scope="scope">
                  {{ getPaymentExamName(scope.row) }}
                </template>
              </el-table-column>
              <el-table-column label="支付金额" min-width="130">
                <template slot-scope="scope">
                  {{ formatInvoiceAmount(scope.row.realityPayMoney) }}元
                </template>
              </el-table-column>
              <el-table-column label="支付时间" min-width="190">
                <template slot-scope="scope">
                  {{ getPaymentTimeText(scope.row) }}
                </template>
              </el-table-column>
              <el-table-column label="支付渠道" min-width="120">
                <template slot-scope="scope">
                  {{ getPaymentChannelText(scope.row.payChannel) }}
                </template>
              </el-table-column>
            </el-table>
            <div class="table-pagination" v-if="showPaymentPagination">
              <el-pagination
                background
                :current-page="paymentPageNo"
                :page-size="paymentPageSize"
                :page-sizes="[10, 20, 50]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="paymentRecords.length"
                @size-change="handlePaymentPageSizeChange"
                @current-change="handlePaymentPageChange"
              />
            </div>
          </div>
        </div>

        <!-- 我的收藏 -->
        <div v-if="activeMenu === 'collection'" class="content-section collection-section">
          <div class="collection-wrapper">
            <div class="collection-tabs">
              <div
                class="collection-tab"
                :class="{ 'collection-tab-active': collectionTab === 'video' }"
                @click="changeCollectionTab('video')"
              >
                视频收藏
              </div>
              <div
                class="collection-tab"
                :class="{ 'collection-tab-active': collectionTab === 'question' }"
                @click="changeCollectionTab('question')"
              >
                题目收藏
              </div>
            </div>

            <div v-if="showCollectionEmpty" class="collection-empty">
              <img :src="emptyRecordImg" alt="暂无收藏" />
              <div class="collection-empty-text">暂无收藏</div>
            </div>

            <template v-else>
              <el-table
                v-if="collectionTab === 'video'"
                :data="pagedVideoCollections"
                v-loading="loadingCollections"
                class="collection-record-table"
                empty-text="暂无收藏"
              >
                <el-table-column label="序号" width="70" align="left">
                  <template slot-scope="scope">
                    {{ getCollectionIndex(scope.$index) }}
                  </template>
                </el-table-column>
                <el-table-column label="视频名称" min-width="260">
                  <template slot-scope="scope">
                    {{ getCollectionVideoName(scope.row) }}
                  </template>
                </el-table-column>
                <el-table-column label="讲师" min-width="150">
                  <template slot-scope="scope">
                    {{ getCollectionVideoTeacher(scope.row) }}
                  </template>
                </el-table-column>
                <el-table-column label="总时长" min-width="140">
                  <template slot-scope="scope">
                    {{ formatVideoDuration(getCollectionVideoDuration(scope.row)) }}
                  </template>
                </el-table-column>
                <el-table-column label="操作" min-width="140">
                  <template slot-scope="scope">
                    <button
                      type="button"
                      class="collection-link-btn"
                      @click="goToCollectedVideo(scope.row)"
                    >
                      去学习
                    </button>
                    <button
                      type="button"
                      class="collection-link-btn collection-link-btn-danger"
                      @click="cancelVideoCollection(scope.row)"
                    >
                      取消收藏
                    </button>
                  </template>
                </el-table-column>
              </el-table>

              <el-table
                v-else
                :data="questionCollections"
                v-loading="loadingCollections"
                class="collection-record-table"
                empty-text="暂无收藏"
              >
                <el-table-column label="序号" width="70" align="left">
                  <template slot-scope="scope">
                    {{ getCollectionIndex(scope.$index) }}
                  </template>
                </el-table-column>
                <el-table-column label="题库名称" min-width="180">
                  <template slot-scope="scope">
                    {{ scope.row.libName || "--" }}
                  </template>
                </el-table-column>
                <el-table-column label="题型" min-width="100">
                  <template slot-scope="scope">
                    {{ Number(scope.row.type) === 0 ? "单选题" : "多选题" }}
                  </template>
                </el-table-column>
                <el-table-column label="题目内容" min-width="320">
                  <template slot-scope="scope">
                    {{ scope.row.content || "--" }}
                  </template>
                </el-table-column>
                <el-table-column label="操作" min-width="140">
                  <template slot-scope="scope">
                    <button
                      type="button"
                      class="collection-link-btn"
                      @click="goToCollectedQuestion(scope.row)"
                    >
                      去答题
                    </button>
                    <button
                      type="button"
                      class="collection-link-btn collection-link-btn-danger"
                      @click="cancelQuestionCollection(scope.row)"
                    >
                      取消收藏
                    </button>
                  </template>
                </el-table-column>
              </el-table>

              <div class="table-pagination" v-if="showCollectionPagination">
                <el-pagination
                  background
                  :current-page="collectionPageNo"
                  :page-size="collectionPageSize"
                  :page-sizes="[10, 20, 50]"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="collectionTotal"
                  @size-change="handleCollectionPageSizeChange"
                  @current-change="handleCollectionPageChange"
                />
              </div>
            </template>
          </div>
        </div>

        <el-dialog
          title="上传论文"
          :visible.sync="paperUploadDialogVisible"
          width="520px"
          :close-on-click-modal="false"
          append-to-body
          custom-class="mine-upload-paper-dialog"
        >
          <div class="upload-paper-dialog-body">
            <div class="upload-file-name" v-if="paperUploadFileName">
              当前文件：{{ paperUploadFileName }}
            </div>
            <el-upload
              class="paper-upload"
              :action="paperUploadAction"
              :show-file-list="false"
              :http-request="handlePaperUploadFile"
              :disabled="uploadingPaper"
            >
              <el-button type="primary" :loading="uploadingPaper">
                {{ uploadingPaper ? "上传中..." : "选择文件" }}
              </el-button>
            </el-upload>
            <div class="upload-paper-tip">仅支持 Word/PDF 文件</div>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="paperUploadDialogVisible = false">关闭</el-button>
          </div>
        </el-dialog>

        <el-dialog
          title="开具发票"
          :visible.sync="invoiceApplyDialogVisible"
          width="760px"
          :close-on-click-modal="false"
          append-to-body
          custom-class="mine-invoice-dialog mine-apply-invoice-dialog"
        >
          <div class="mine-invoice-dialog-body">
            <el-form label-width="110px" class="mine-invoice-form">
              <el-form-item label="发票抬头" :required="true">
                <el-radio-group
                  v-model="invoiceApplyForm.invoiceType"
                  @change="handleInvoiceTypeChange"
                >
                  <el-radio label="0">医院单位</el-radio>
                  <el-radio label="1">个人</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                :label="
                  invoiceApplyForm.invoiceType === '0' ? '单位名称' : '个人名称'
                "
                :required="true"
              >
                <el-input
                  v-model="invoiceApplyForm.invoiceHeader"
                  :placeholder="
                    '请填写' +
                    (invoiceApplyForm.invoiceType === '0'
                      ? '单位名称'
                      : '个人名称')
                  "
                />
              </el-form-item>
              <el-form-item
                v-if="invoiceApplyForm.invoiceType === '0'"
                label="纳税识别号"
                :required="true"
              >
                <el-input
                  v-model="invoiceApplyForm.taxNo"
                  placeholder="请填写纳税人识别号"
                />
              </el-form-item>
              <el-form-item label="收票人邮箱" :required="true">
                <el-input
                  v-model="invoiceApplyForm.email"
                  placeholder="用于向您发送电子发票"
                />
              </el-form-item>
              <el-divider
                v-if="invoiceApplyForm.invoiceType === '0'"
                content-position="center"
              >
                更多内容(选填)
              </el-divider>
              <el-form-item
                v-if="invoiceApplyForm.invoiceType === '0'"
                label="注册地址"
              >
                <el-input
                  v-model="invoiceApplyForm.address"
                  placeholder="请填写注册地址"
                />
              </el-form-item>
              <el-form-item
                v-if="invoiceApplyForm.invoiceType === '0'"
                label="注册电话"
              >
                <el-input
                  v-model="invoiceApplyForm.telephone"
                  placeholder="请填写注册电话"
                />
              </el-form-item>
              <el-form-item
                v-if="invoiceApplyForm.invoiceType === '0'"
                label="开户银行"
              >
                <el-input
                  v-model="invoiceApplyForm.bankName"
                  placeholder="请填写开户银行"
                />
              </el-form-item>
              <el-form-item
                v-if="invoiceApplyForm.invoiceType === '0'"
                label="银行账号"
              >
                <el-input
                  v-model="invoiceApplyForm.bankNo"
                  placeholder="请填写银行账号"
                />
              </el-form-item>
              <el-form-item label="开票金额">
                {{ formatInvoiceAmount(invoiceApplyPrice) }}元
              </el-form-item>
              <el-form-item label="发票内容">
                {{ invoiceContent || "--" }}
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="invoiceApplyDialogVisible = false">取消</el-button>
            <el-button
              type="primary"
              :loading="invoiceApplying"
              @click="submitInvoiceApply"
            >
              提交申请
            </el-button>
          </div>
        </el-dialog>

        <el-dialog
          title="发票详情"
          :visible.sync="invoiceDetailDialogVisible"
          width="760px"
          append-to-body
          custom-class="mine-invoice-dialog mine-invoice-detail-dialog"
        >
          <div class="mine-invoice-dialog-body">
            <el-form label-width="110px" class="mine-invoice-form">
              <el-form-item label="电子发票">
                <span
                  class="invoice-status-text"
                  :class="{
                    'invoice-status-success': isInvoiceDetailSuccess,
                    'invoice-status-fail': isInvoiceDetailFailed
                  }"
                >
                  {{ invoiceDetailStatusText }}
                </span>
              </el-form-item>
              <el-form-item :label="invoiceDetailNameLabel">
                {{ invoiceDetailRecord.companyName || invoiceDetailRecord.personName || "--" }}
              </el-form-item>
              <el-form-item
                v-if="invoiceDetailRecord.invoiceType === 0 || invoiceDetailRecord.invoiceType === '0'"
                label="纳税识别号"
              >
                {{ invoiceDetailRecord.dutyParagraph || "--" }}
              </el-form-item>
              <el-form-item label="发票金额">
                {{ formatInvoiceAmount(invoiceDetailRecord.money) }}元
              </el-form-item>
              <el-form-item label="申请时间">
                {{ formatDateTime(invoiceDetailRecord.applyTime) }}
              </el-form-item>
              <el-form-item label="发票内容">
                {{ invoiceDetailRecord.content || "--" }}
              </el-form-item>
              <el-form-item
                v-if="invoiceDetailRecord.invoiceType === 0 || invoiceDetailRecord.invoiceType === '0'"
                label="注册地址"
              >
                {{ invoiceDetailRecord.address || "--" }}
              </el-form-item>
              <el-form-item
                v-if="invoiceDetailRecord.invoiceType === 0 || invoiceDetailRecord.invoiceType === '0'"
                label="注册电话"
              >
                {{ invoiceDetailRecord.phone || "--" }}
              </el-form-item>
              <el-form-item
                v-if="invoiceDetailRecord.invoiceType === 0 || invoiceDetailRecord.invoiceType === '0'"
                label="开户银行"
              >
                {{ invoiceDetailRecord.bankName || "--" }}
              </el-form-item>
              <el-form-item
                v-if="invoiceDetailRecord.invoiceType === 0 || invoiceDetailRecord.invoiceType === '0'"
                label="银行账号"
              >
                {{ invoiceDetailRecord.bankAccount || "--" }}
              </el-form-item>
              <el-form-item label="收票人邮箱">
                {{ invoiceDetailRecord.email || "--" }}
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="invoiceDetailDialogVisible = false">关闭</el-button>
          </div>
        </el-dialog>

        <el-dialog
          :visible.sync="certDialogVisible"
          width="720px"
          append-to-body
          custom-class="mine-cert-dialog"
        >
          <div slot="title" class="cert-dialog-header">
            <span class="cert-dialog-title">查看证书</span>
            <el-button
              type="primary"
              size="small"
              icon="el-icon-download"
              :loading="downloadingCert"
              @click="downloadCertificate"
            >
              下载证书
            </el-button>
          </div>
          <div class="cert-preview-body" v-loading="certificateLoading">
            <iframe
              v-if="certPreviewUrl && isPdfUrl(certPreviewUrl)"
              :src="certPreviewUrl"
              title="证书预览"
              class="cert-preview-pdf"
            />
            <img
              v-else-if="certPreviewUrl"
              :src="certPreviewUrl"
              alt="证书预览"
            />
            <div v-else class="cert-preview-empty">暂无证书</div>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { httpRequest } from "@/axios/axios-api";

const STATUS_UNKNOWN = "未知";

export default {
  name: "Mine",
  data() {
    return {
      activeMenu: "profile",
      defaultAvatar: require("@/assets/defaultAvatar.png"),
      userInfo: {},
      userInfoLoaded: false,
      unreadCount: 0,
      trainingRecords: [],
      recordPageNo: 1,
      recordPageSize: 10,
      invoiceRecords: [],
      invoicePageNo: 1,
      invoicePageSize: 10,
      loadingInvoiceRecords: false,
      paymentRecords: [],
      paymentPageNo: 1,
      paymentPageSize: 10,
      loadingPaymentRecords: false,
      collectionTab: "video",
      videoCollections: [],
      questionCollections: [],
      collectionPageNo: 1,
      collectionPageSize: 10,
      collectionTotal: 0,
      loadingCollections: false,
      emptyRecordImg: require("@/assets/mine/emptyRecord.png"),
      invoiceApplyDialogVisible: false,
      invoiceApplying: false,
      invoiceApplyTarget: null,
      invoiceApplyForm: {
        invoiceType: "0",
        invoiceHeader: "",
        taxNo: "",
        email: "",
        address: "",
        telephone: "",
        bankName: "",
        bankNo: ""
      },
      invoiceContent: "",
      invoiceDetailDialogVisible: false,
      invoiceDetailRecord: {},
      messages: [],
      loading: false,
      certDialogVisible: false,
      certPreviewUrl: "",
      certificateLoading: false,
      downloadingCert: false,
      selectedRecordForAction: null,
      paperUploadDialogVisible: false,
      paperUploadAction: "/file/importOffice",
      paperUploadFileName: "",
      uploadingPaper: false,
      menuTitles: {
        profile: "个人信息",
        records: "培训记录",
        messages: "消息中心",
        realName: "实名认证",
        transfer: "护士转岗",
        invoice: "开具发票",
        payment: "缴费记录",
        collection: "我的收藏"
      },
      messagePageNo: 1,
      messagePageSize: 10,
      messageTotalCount: 0,
      messageDialogVisible: false,
      currentMessageTitle: "",
      currentMessageContent: "",
      checkingMessage: false,
      markingAllRead: false,
      transferLicensePlaceholder: require("@/assets/realname/hos_cert_img_bg.png"),
      transferForm: {
        majorType: 0,
        majorId: null,
        hospital: "",
        position: "",
        hospitalLevel: "",
        officePhone: "",
        licenseUrl: ""
      },
      transferMajorList: [],
      transferHospitalList: [],
      loadingTransferMajorList: false,
      loadingTransferHospital: false,
      uploadingTransferLicense: false,
      submittingTransfer: false
    };
  },
  computed: {
    userAvatarUrl() {
      return (
        this.userInfo.avatar ||
        this.userInfo.avatarUrl ||
        this.userInfo.pictureUrl ||
        this.defaultAvatar
      );
    },
    displayName() {
      return (
        this.userInfo.realName ||
        this.userInfo.nickname ||
        this.userInfo.nickName ||
        this.userInfo.phone ||
        "未设置"
      );
    },
    hospitalName() {
      const weHospital =
        this.userInfo &&
        this.userInfo.we &&
        this.userInfo.we.hospital
          ? this.userInfo.we.hospital
          : "";
      return weHospital || this.userInfo.hospital || this.userInfo.expertHospital || "";
    },
    authStatusText() {
      const status = this.userInfo.authStatus;
      if (status === 2) return "已认证";
      if (status === 1) return "审核中";
      if (status === 3) return "已驳回";
      return "未认证"; // Default or 0
    },
    authStatusColor() {
      const status = this.userInfo.authStatus;
      if (status === 2) return "#0AB08A";
      if (status === 1) return "#E99D42";
      if (status === 3) return "#E74E4E";
      return "#9A9A9A"; // Default or 0
    },
    pagedTrainingRecords() {
      if (!Array.isArray(this.trainingRecords) || this.trainingRecords.length < 1) {
        return [];
      }
      const pageNo = Number(this.recordPageNo);
      const pageSize = Number(this.recordPageSize);
      const validPageNo = Number.isFinite(pageNo) && pageNo > 0 ? pageNo : 1;
      const validPageSize =
        Number.isFinite(pageSize) && pageSize > 0 ? pageSize : 10;
      const start = (validPageNo - 1) * validPageSize;
      return this.trainingRecords.slice(start, start + validPageSize);
    },
    pagedInvoiceRecords() {
      if (!Array.isArray(this.invoiceRecords) || this.invoiceRecords.length < 1) {
        return [];
      }
      const pageNo = Number(this.invoicePageNo);
      const pageSize = Number(this.invoicePageSize);
      const validPageNo = Number.isFinite(pageNo) && pageNo > 0 ? pageNo : 1;
      const validPageSize =
        Number.isFinite(pageSize) && pageSize > 0 ? pageSize : 10;
      const start = (validPageNo - 1) * validPageSize;
      return this.invoiceRecords.slice(start, start + validPageSize);
    },
    pagedPaymentRecords() {
      if (!Array.isArray(this.paymentRecords) || this.paymentRecords.length < 1) {
        return [];
      }
      const pageNo = Number(this.paymentPageNo);
      const pageSize = Number(this.paymentPageSize);
      const validPageNo = Number.isFinite(pageNo) && pageNo > 0 ? pageNo : 1;
      const validPageSize =
        Number.isFinite(pageSize) && pageSize > 0 ? pageSize : 10;
      const start = (validPageNo - 1) * validPageSize;
      return this.paymentRecords.slice(start, start + validPageSize);
    },
    showInvoicePagination() {
      return this.invoiceRecords.length > this.invoicePageSize;
    },
    showPaymentPagination() {
      return this.paymentRecords.length > this.paymentPageSize;
    },
    pagedVideoCollections() {
      if (!Array.isArray(this.videoCollections) || this.videoCollections.length < 1) {
        return [];
      }
      const pageNo = Number(this.collectionPageNo);
      const pageSize = Number(this.collectionPageSize);
      const validPageNo = Number.isFinite(pageNo) && pageNo > 0 ? pageNo : 1;
      const validPageSize =
        Number.isFinite(pageSize) && pageSize > 0 ? pageSize : 10;
      const start = (validPageNo - 1) * validPageSize;
      return this.videoCollections.slice(start, start + validPageSize);
    },
    showCollectionPagination() {
      return Number(this.collectionTotal) > Number(this.collectionPageSize);
    },
    showCollectionEmpty() {
      if (this.loadingCollections) {
        return false;
      }
      if (this.collectionTab === "video") {
        return this.videoCollections.length < 1;
      }
      return this.questionCollections.length < 1;
    },
    invoiceApplyPrice() {
      return this.invoiceApplyTarget &&
        Number.isFinite(Number(this.invoiceApplyTarget.realityPayMoney))
        ? Number(this.invoiceApplyTarget.realityPayMoney)
        : 0;
    },
    invoiceDetailStatusText() {
      return this.getInvoiceStatusText({ invoice: this.invoiceDetailRecord });
    },
    isInvoiceDetailSuccess() {
      return this.isInvoiceSuccess({ invoice: this.invoiceDetailRecord });
    },
    isInvoiceDetailFailed() {
      return this.isInvoiceFailed({ invoice: this.invoiceDetailRecord });
    },
    invoiceDetailNameLabel() {
      const invoiceType = Number(this.invoiceDetailRecord.invoiceType);
      return invoiceType === 0 ? "单位名称" : "个人名称";
    },
    isTransferAvailable() {
      return this.userInfoLoaded && Number(this.userInfo.authStatus) === 2;
    }
  },
  created() {
    this.loadUserInfo();
    this.loadUnreadCount();
  },
  methods: {
    normalizeUnreadCount(data) {
      if (typeof data === "number") {
        return data;
      }
      if (typeof data === "string") {
        const parsed = Number(data);
        return Number.isNaN(parsed) ? 0 : parsed;
      }
      if (Array.isArray(data)) {
        return data.length;
      }
      if (data && typeof data === "object") {
        const candidates = [
          data.isNotBrowseNum,
          data.unreadCount,
          data.count,
          data.total
        ];
        for (let i = 0; i < candidates.length; i += 1) {
          const value = Number(candidates[i]);
          if (!Number.isNaN(value)) {
            return value;
          }
        }
      }
      return 0;
    },
    normalizeMessageList(data) {
      let list = [];
      if (Array.isArray(data)) {
        list = data;
      } else if (data && typeof data === "object") {
        if (Array.isArray(data.list)) {
          list = data.list;
        } else if (Array.isArray(data.records)) {
          list = data.records;
        } else if (Array.isArray(data.items)) {
          list = data.items;
        }
      }
      return list.map(item => ({
        ...item,
        isRead: !!item.isBrowse || item.isRead === true
      }));
    },
    normalizeTrainingList(data) {
      if (Array.isArray(data)) {
        return data;
      }
      if (data && typeof data === "object") {
        if (Array.isArray(data.list)) {
          return data.list;
        }
        if (Array.isArray(data.records)) {
          return data.records;
        }
        if (Array.isArray(data.items)) {
          return data.items;
        }
      }
      return [];
    },
    normalizeInvoiceList(data) {
      if (Array.isArray(data)) {
        return data;
      }
      if (data && typeof data === "object") {
        if (Array.isArray(data.list)) {
          return data.list;
        }
        if (Array.isArray(data.records)) {
          return data.records;
        }
        if (Array.isArray(data.items)) {
          return data.items;
        }
      }
      return [];
    },
    normalizePaymentList(data) {
      if (Array.isArray(data)) {
        return data;
      }
      if (data && typeof data === "object") {
        if (Array.isArray(data.list)) {
          return data.list;
        }
        if (Array.isArray(data.records)) {
          return data.records;
        }
        if (Array.isArray(data.items)) {
          return data.items;
        }
      }
      return [];
    },
    resetTransferForm() {
      this.transferForm = {
        majorType: 0,
        majorId: null,
        hospital: "",
        position: "",
        hospitalLevel: "",
        officePhone: "",
        licenseUrl: ""
      };
      this.transferHospitalList = [];
      this.loadingTransferHospital = false;
      this.uploadingTransferLicense = false;
      this.submittingTransfer = false;
    },
    normalizeTransferMajorList(list) {
      if (!Array.isArray(list)) {
        return [];
      }
      return list
        .map(item => {
          const majorId = Number(item && item.majorId);
          const majorType = Number(
            item && item.type !== undefined ? item.type : 0
          );
          return {
            majorId: Number.isFinite(majorId) ? majorId : null,
            majorType: Number.isFinite(majorType) ? majorType : 0,
            name: (item && item.name) || ""
          };
        })
        .filter(item => item.majorId !== null && item.name.length > 0);
    },
    async loadTransferMajorList() {
      if (!this.isTransferAvailable) {
        this.transferMajorList = [];
        this.transferForm.majorId = null;
        return;
      }
      this.loadingTransferMajorList = true;
      try {
        const res = await httpRequest("/app/major/majors", "get");
        if (!(res && res.code === 200)) {
          this.transferMajorList = [];
          this.$message.error((res && res.message) || "加载专业列表失败");
          return;
        }
        this.transferMajorList = this.normalizeTransferMajorList(res.data);
      } catch (error) {
        void error;
        this.transferMajorList = [];
        this.$message.error("加载专业列表失败");
      } finally {
        this.loadingTransferMajorList = false;
      }
    },
    async loadTransferHospital(keyword) {
      if (!keyword || !String(keyword).trim()) {
        this.transferHospitalList = [];
        return;
      }
      this.loadingTransferHospital = true;
      try {
        const res = await httpRequest("/app/hospital/hospitals", "get", {
          queryParam: String(keyword).trim()
        });
        if (res && res.code === 200 && Array.isArray(res.data)) {
          this.transferHospitalList = res.data;
          return;
        }
        this.transferHospitalList = [];
      } catch (error) {
        void error;
        this.transferHospitalList = [];
      } finally {
        this.loadingTransferHospital = false;
      }
    },
    validateTransferForm() {
      if (!this.isTransferAvailable) {
        this.$message.warning("请先完成实名认证");
        return false;
      }
      if (!Number.isFinite(Number(this.transferForm.majorId))) {
        this.$message.warning("请选择专业");
        return false;
      }
      if (!String(this.transferForm.hospital || "").trim()) {
        this.$message.warning("请输入医院名称");
        return false;
      }
      if (!String(this.transferForm.position || "").trim()) {
        this.$message.warning("请输入职称");
        return false;
      }
      if (!String(this.transferForm.hospitalLevel || "").trim()) {
        this.$message.warning("请输入医院等级");
        return false;
      }
      if (!String(this.transferForm.officePhone || "").trim()) {
        this.$message.warning("请填写办公室电话");
        return false;
      }
      if (!String(this.transferForm.licenseUrl || "").trim()) {
        this.$message.warning("请上传医疗机构执业许可证副本");
        return false;
      }
      return true;
    },
    buildTransferPayload() {
      const selectedMajor = this.transferMajorList.find(
        item => Number(item.majorId) === Number(this.transferForm.majorId)
      );
      return {
        majorType:
          selectedMajor && Number.isFinite(Number(selectedMajor.majorType))
            ? Number(selectedMajor.majorType)
            : 0,
        majorId: Number(this.transferForm.majorId),
        hospital: String(this.transferForm.hospital || "").trim(),
        position: String(this.transferForm.position || "").trim(),
        hospitalLevel: String(this.transferForm.hospitalLevel || "").trim(),
        officePhone: String(this.transferForm.officePhone || "").trim(),
        licenseUrl: String(this.transferForm.licenseUrl || "").trim()
      };
    },
    async handleTransferLicenseUpload(params) {
      if (!params || !params.file || this.uploadingTransferLicense) {
        return;
      }
      const previousUrl = this.transferForm.licenseUrl;
      this.uploadingTransferLicense = true;
      this.transferForm.licenseUrl = URL.createObjectURL(params.file);
      const formData = new FormData();
      formData.append("pictureFile", params.file);
      try {
        const res = await httpRequest("/file/importPicture", "post", formData);
        if (
          !(res && res.code === 200 && Array.isArray(res.data) && res.data[0])
        ) {
          this.transferForm.licenseUrl = previousUrl;
          this.$message.error("上传失败，请重试");
          if (params.onError) {
            params.onError(new Error("UPLOAD_LICENSE_FAILED"));
          }
          return;
        }
        this.transferForm.licenseUrl = String(res.data[0]);
        this.$message.success("上传成功");
        if (params.onSuccess) {
          params.onSuccess(res, params.file);
        }
      } catch (error) {
        this.transferForm.licenseUrl = previousUrl;
        this.$message.error("上传失败，请重试");
        if (params.onError) {
          params.onError(error);
        }
      } finally {
        this.uploadingTransferLicense = false;
      }
    },
    async handleTransferSubmit() {
      if (this.submittingTransfer || this.uploadingTransferLicense) {
        return;
      }
      if (!this.validateTransferForm()) {
        return;
      }
      try {
        await this.$confirm("确定转岗吗？提交后立即生效", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        });
      } catch (error) {
        void error;
        return;
      }
      this.submittingTransfer = true;
      try {
        const res = await httpRequest(
          "/app/user/zhuanGang",
          "put",
          this.buildTransferPayload()
        );
        if (!(res && res.code === 200)) {
          this.$message.error((res && res.message) || "转岗失败，请稍后重试");
          return;
        }
        this.$message.success("转岗成功");
        await this.loadUserInfo();
        this.resetTransferForm();
        await this.loadTransferMajorList();
      } catch (error) {
        void error;
        this.$message.error("转岗失败，请稍后重试");
      } finally {
        this.submittingTransfer = false;
      }
    },
    parseDateTime(value) {
      if (!value) {
        return null;
      }
      if (value instanceof Date) {
        return Number.isNaN(value.getTime()) ? null : value;
      }
      const normalized = String(value).replace(/-/g, "/");
      const parsed = new Date(normalized);
      if (!Number.isNaN(parsed.getTime())) {
        return parsed;
      }
      const fallback = new Date(value);
      return Number.isNaN(fallback.getTime()) ? null : fallback;
    },
    formatDateOnly(value) {
      const date = this.parseDateTime(value);
      if (!date) {
        return "--";
      }
      const year = date.getFullYear();
      const month = `${date.getMonth() + 1}`.padStart(2, "0");
      const day = `${date.getDate()}`.padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    formatDateTime(value) {
      if (!value) {
        return "--";
      }
      const text = String(value).replace("T", " ").trim();
      if (!text) {
        return "--";
      }
      if (text.length >= 19) {
        return text.slice(0, 19);
      }
      const date = this.parseDateTime(value);
      if (!date) {
        return text;
      }
      const year = date.getFullYear();
      const month = `${date.getMonth() + 1}`.padStart(2, "0");
      const day = `${date.getDate()}`.padStart(2, "0");
      const hour = `${date.getHours()}`.padStart(2, "0");
      const minute = `${date.getMinutes()}`.padStart(2, "0");
      const second = `${date.getSeconds()}`.padStart(2, "0");
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    },
    getApplyEnrollTime(item) {
      if (!item) {
        return "--";
      }
      const apply = item.apply || {};
      const candidates = [
        apply.createTime,
        apply.payTime,
        apply.payFinishTime,
        item.createTime
      ];
      for (let i = 0; i < candidates.length; i += 1) {
        const value = candidates[i];
        if (value) {
          return this.formatDateTime(value);
        }
      }
      return "--";
    },
    getTrainMajorName(item) {
      if (!item) {
        return "--";
      }
      return (item.major && item.major.name) || item.majorName || "--";
    },
    getRecordIndex(localIndex) {
      return (this.recordPageNo - 1) * this.recordPageSize + localIndex + 1;
    },
    handleRecordPageChange(pageNo) {
      this.recordPageNo = pageNo;
    },
    handleRecordPageSizeChange(pageSize) {
      this.recordPageSize = pageSize;
      this.recordPageNo = 1;
    },
    getInvoiceIndex(localIndex) {
      return (this.invoicePageNo - 1) * this.invoicePageSize + localIndex + 1;
    },
    handleInvoicePageChange(pageNo) {
      this.invoicePageNo = pageNo;
    },
    handleInvoicePageSizeChange(pageSize) {
      this.invoicePageSize = pageSize;
      this.invoicePageNo = 1;
    },
    getPaymentIndex(localIndex) {
      return (this.paymentPageNo - 1) * this.paymentPageSize + localIndex + 1;
    },
    handlePaymentPageChange(pageNo) {
      this.paymentPageNo = pageNo;
    },
    handlePaymentPageSizeChange(pageSize) {
      this.paymentPageSize = pageSize;
      this.paymentPageNo = 1;
    },
    getPaymentExamName(item) {
      if (!item) {
        return "--";
      }
      if (item.exam && item.exam.name) {
        return item.exam.name;
      }
      if (item.name) {
        return item.name;
      }
      if (item.examName) {
        return item.examName;
      }
      if (item.exam_name) {
        return item.exam_name;
      }
      return "--";
    },
    getPaymentTimeForSort(item) {
      if (!item) {
        return 0;
      }
      const candidates = [item.payFinishTime, item.payTime, item.createTime];
      for (let i = 0; i < candidates.length; i += 1) {
        const date = this.parseDateTime(candidates[i]);
        if (date) {
          return date.getTime();
        }
      }
      return 0;
    },
    getPaymentTimeText(item) {
      if (!item) {
        return "--";
      }
      if (item.payFinishTime) {
        return this.formatDateTime(item.payFinishTime);
      }
      if (item.payTime) {
        return this.formatDateTime(item.payTime);
      }
      if (item.createTime) {
        return this.formatDateTime(item.createTime);
      }
      return "--";
    },
    getPaymentChannelText(channel) {
      const value = Number(channel);
      if (value === 1) {
        return "支付宝";
      }
      if (value === 2) {
        return "微信";
      }
      if (value === 11) {
        return "银联支付宝";
      }
      if (value === 12) {
        return "银联微信";
      }
      if (value === 3) {
        return "银联扫码";
      }
      if (value === 4) {
        return "后台代报名";
      }
      return "未支付";
    },
    normalizeVideoCollectionList(data) {
      if (Array.isArray(data)) {
        return data;
      }
      if (data && typeof data === "object") {
        if (Array.isArray(data.list)) {
          return data.list;
        }
        if (Array.isArray(data.records)) {
          return data.records;
        }
        if (Array.isArray(data.items)) {
          return data.items;
        }
      }
      return [];
    },
    normalizeQuestionCollectionData(data) {
      const fallback = {
        list: [],
        total: 0
      };
      if (Array.isArray(data)) {
        return {
          list: data,
          total: data.length
        };
      }
      if (!data || typeof data !== "object") {
        return fallback;
      }
      const list = Array.isArray(data.list)
        ? data.list
        : Array.isArray(data.records)
        ? data.records
        : Array.isArray(data.items)
        ? data.items
        : [];
      const totalCandidates = [
        data.totalRecord,
        data.total,
        data.totalCount,
        data.count
      ];
      let total = list.length;
      for (let i = 0; i < totalCandidates.length; i += 1) {
        const parsed = Number(totalCandidates[i]);
        if (Number.isFinite(parsed) && parsed >= 0) {
          total = parsed;
          break;
        }
      }
      return {
        list,
        total
      };
    },
    getCollectionIndex(localIndex) {
      return (this.collectionPageNo - 1) * this.collectionPageSize + localIndex + 1;
    },
    getCollectionVideoName(item) {
      const video = (item && item.video) || {};
      return video.name || item.name || "--";
    },
    getCollectionVideoTeacher(item) {
      const video = (item && item.video) || {};
      return video.teacher || "--";
    },
    getCollectionVideoDuration(item) {
      const video = (item && item.video) || {};
      const duration = Number(video.duration);
      return Number.isFinite(duration) && duration >= 0 ? duration : 0;
    },
    formatVideoDuration(duration) {
      const totalSeconds = Number(duration);
      if (!Number.isFinite(totalSeconds) || totalSeconds < 0) {
        return "--";
      }
      const seconds = Math.floor(totalSeconds);
      const hour = Math.floor(seconds / 3600);
      const minute = Math.floor((seconds % 3600) / 60);
      const second = seconds % 60;
      if (hour > 0) {
        return `${hour}时${minute}分${second}秒`;
      }
      return `${minute}分${second}秒`;
    },
    changeCollectionTab(tab) {
      if (tab !== "video" && tab !== "question") {
        return;
      }
      if (this.collectionTab === tab) {
        return;
      }
      this.collectionTab = tab;
      this.collectionPageNo = 1;
      this.loadCollectionData();
    },
    handleCollectionPageChange(pageNo) {
      this.collectionPageNo = pageNo;
      if (this.collectionTab === "question") {
        this.loadQuestionCollections();
      }
    },
    handleCollectionPageSizeChange(pageSize) {
      this.collectionPageSize = pageSize;
      this.collectionPageNo = 1;
      if (this.collectionTab === "question") {
        this.loadQuestionCollections();
      }
    },
    async loadCollectionData() {
      if (this.collectionTab === "question") {
        await this.loadQuestionCollections();
        return;
      }
      await this.loadVideoCollections();
    },
    async loadVideoCollections() {
      this.loadingCollections = true;
      try {
        const res = await httpRequest("/app/course/collect/collects", "get", null);
        if (!(res && res.code === 200)) {
          this.videoCollections = [];
          this.collectionTotal = 0;
          return;
        }
        const list = this.normalizeVideoCollectionList(res.data);
        this.videoCollections = list
          .slice()
          .sort((a, b) => this.getPaymentTimeForSort(b) - this.getPaymentTimeForSort(a));
        this.collectionTotal = this.videoCollections.length;
        const maxPage = Math.max(
          1,
          Math.ceil(this.collectionTotal / this.collectionPageSize)
        );
        if (this.collectionPageNo > maxPage) {
          this.collectionPageNo = maxPage;
        }
      } catch (error) {
        console.error("加载视频收藏失败:", error);
        this.videoCollections = [];
        this.collectionTotal = 0;
      } finally {
        this.loadingCollections = false;
      }
    },
    async loadQuestionCollections() {
      this.loadingCollections = true;
      try {
        const params = {
          currentPage: this.collectionPageNo,
          pageSize: this.collectionPageSize
        };
        const res = await httpRequest(
          "/app/answer/qust-collect-records",
          "get",
          params
        );
        if (!(res && res.code === 200)) {
          this.questionCollections = [];
          this.collectionTotal = 0;
          return;
        }
        const normalized = this.normalizeQuestionCollectionData(res.data);
        this.questionCollections = normalized.list;
        this.collectionTotal = normalized.total;
        if (
          this.collectionPageNo > 1 &&
          this.questionCollections.length < 1 &&
          this.collectionTotal > 0
        ) {
          this.collectionPageNo -= 1;
          await this.loadQuestionCollections();
        }
      } catch (error) {
        console.error("加载题目收藏失败:", error);
        this.questionCollections = [];
        this.collectionTotal = 0;
      } finally {
        this.loadingCollections = false;
      }
    },
    goToCollectedVideo(item) {
      const vcId = Number(item && item.vcId);
      const csId = Number(item && item.video && item.video.csId);
      if (!Number.isFinite(vcId) || vcId <= 0) {
        this.$message.warning("课程信息异常");
        return;
      }
      const query = {
        vcId: String(vcId)
      };
      if (Number.isFinite(csId) && csId > 0) {
        query.csId = String(csId);
      }
      const arIdCandidates = [
        item && item.arId,
        item && item.apply && item.apply.arId,
        item && item.video && item.video.apply && item.video.apply.arId
      ];
      const resolvedArId = arIdCandidates
        .map(arId => Number(arId))
        .find(arId => Number.isFinite(arId) && arId > 0);
      if (resolvedArId) {
        query.arId = String(resolvedArId);
      }
      this.$router.push({
        path: "/videoCourse",
        query
      });
    },
    goToCollectedQuestion(item) {
      const libId = Number(item && item.libId);
      const eqId = Number(item && item.eqId);
      if (!Number.isFinite(libId) || libId <= 0 || !Number.isFinite(eqId) || eqId <= 0) {
        this.$message.warning("题目信息异常");
        return;
      }
      this.$router.push({
        path: "/practiceLibExam",
        query: {
          libId: String(libId),
          eqId: String(eqId),
          answerType: "0"
        }
      });
    },
    async cancelVideoCollection(item) {
      const vcId = Number(item && item.vcId);
      if (!Number.isFinite(vcId) || vcId <= 0) {
        this.$message.warning("课程信息异常");
        return;
      }
      try {
        await this.$confirm("确定取消该收藏吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        });
      } catch (error) {
        void error;
        return;
      }
      try {
        const res = await httpRequest("/app/course/collect", "put", {
          vcId,
          validFlag: false
        });
        if (!(res && res.code === 200)) {
          this.$message.error((res && res.message) || "取消收藏失败");
          return;
        }
        this.$message.success("已取消收藏");
        this.videoCollections = this.videoCollections.filter(
          row => Number(row && row.vcId) !== vcId
        );
        this.collectionTotal = this.videoCollections.length;
        const maxPage = Math.max(
          1,
          Math.ceil(this.collectionTotal / this.collectionPageSize)
        );
        if (this.collectionPageNo > maxPage) {
          this.collectionPageNo = maxPage;
        }
      } catch (error) {
        console.error("取消视频收藏失败:", error);
        this.$message.error("取消收藏失败");
      }
    },
    async cancelQuestionCollection(item) {
      const eqId = Number(item && item.eqId);
      if (!Number.isFinite(eqId) || eqId <= 0) {
        this.$message.warning("题目信息异常");
        return;
      }
      try {
        await this.$confirm("确定取消该收藏吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        });
      } catch (error) {
        void error;
        return;
      }
      try {
        const res = await httpRequest(
          `/app/answer/qust-collect-record/${eqId}`,
          "put",
          null
        );
        if (!(res && res.code === 200)) {
          this.$message.error((res && res.message) || "取消收藏失败");
          return;
        }
        this.$message.success("已取消收藏");
        if (this.questionCollections.length === 1 && this.collectionPageNo > 1) {
          this.collectionPageNo -= 1;
        }
        await this.loadQuestionCollections();
      } catch (error) {
        console.error("取消题目收藏失败:", error);
        this.$message.error("取消收藏失败");
      }
    },
    getInvoiceExamName(item) {
      if (!item) {
        return "--";
      }
      if (item.exam && item.exam.name) {
        return item.exam.name;
      }
      if (item.examName) {
        return item.examName;
      }
      if (item.exam_name) {
        return item.exam_name;
      }
      return "--";
    },
    formatInvoiceAmount(value) {
      const num = Number(value);
      if (!Number.isFinite(num)) {
        return "0.00";
      }
      return num.toFixed(2);
    },
    getInvoiceRawRecord(item) {
      if (!item || !item.invoice || typeof item.invoice !== "object") {
        return null;
      }
      return item.invoice;
    },
    getInvoiceTimeForSort(item) {
      const invoice = this.getInvoiceRawRecord(item);
      const candidates = invoice
        ? [
            invoice.applyTime,
            invoice.sendTime,
            invoice.checkTime,
            invoice.invoiceDate
          ]
        : [item && item.payFinishTime, item && item.payTime, item && item.createTime];
      for (let i = 0; i < candidates.length; i += 1) {
        const date = this.parseDateTime(candidates[i]);
        if (date) {
          return date.getTime();
        }
      }
      return 0;
    },
    getInvoiceTimeText(item) {
      const invoice = this.getInvoiceRawRecord(item);
      if (invoice) {
        const candidates = [
          invoice.applyTime,
          invoice.sendTime,
          invoice.checkTime,
          invoice.invoiceDate
        ];
        for (let i = 0; i < candidates.length; i += 1) {
          if (candidates[i]) {
            return this.formatDateTime(candidates[i]);
          }
        }
      }
      return "--";
    },
    getInvoiceFailReason(item) {
      const invoice = this.getInvoiceRawRecord(item);
      if (!invoice) {
        return "";
      }
      const candidates = [
        invoice.sendBillMsg,
        invoice.send_bill_msg,
        invoice.errorMessage,
        invoice.message,
        invoice.msg,
        invoice.remark
      ];
      for (let i = 0; i < candidates.length; i += 1) {
        const text = String(candidates[i] || "").trim();
        if (text) {
          return text;
        }
      }
      return "";
    },
    getInvoiceStatusText(item) {
      const invoice = this.getInvoiceRawRecord(item);
      if (!invoice) {
        return "未开票";
      }
      const type = Number(invoice.type);
      const status = Number(invoice.status);
      const reason = this.getInvoiceFailReason(item);
      const appendReason = text => (reason ? `${text}，${reason}` : text);
      if (type === 0) {
        if (status === 1) {
          return "冲红中";
        }
        if (status === 2) {
          return "已冲红";
        }
        return appendReason("冲红失败");
      }
      if (status === 0) {
        return "审核中";
      }
      if (status === 1) {
        return "开票中";
      }
      if (status === 2) {
        return "开票成功";
      }
      if (status === 5) {
        return "已冲红";
      }
      return appendReason("开票失败");
    },
    isInvoiceSuccess(item) {
      const invoice = this.getInvoiceRawRecord(item);
      return !!invoice && Number(invoice.type) === 1 && Number(invoice.status) === 2;
    },
    isInvoiceFailed(item) {
      const invoice = this.getInvoiceRawRecord(item);
      if (!invoice) {
        return false;
      }
      const type = Number(invoice.type);
      const status = Number(invoice.status);
      if (type === 0) {
        return status !== 1 && status !== 2;
      }
      return status === 3 || status === 4;
    },
    getInvoiceAction(item) {
      const invoice = this.getInvoiceRawRecord(item);
      if (!invoice) {
        return { type: "APPLY", label: "开具发票" };
      }
      const type = Number(invoice.type);
      const status = Number(invoice.status);
      if (type === 0 && status === 2) {
        return { type: "APPLY", label: "重新开票" };
      }
      if (type === 1 && status === 2 && String(invoice.pdf || "").trim()) {
        return { type: "DOWNLOAD", label: "下载发票" };
      }
      return { type: "DETAIL", label: "查看详情" };
    },
    resetInvoiceApplyForm() {
      this.invoiceApplyForm = {
        invoiceType: "0",
        invoiceHeader: "",
        taxNo: "",
        email: "",
        address: "",
        telephone: "",
        bankName: "",
        bankNo: ""
      };
    },
    fillInvoiceApplyFormByRecord(item) {
      this.resetInvoiceApplyForm();
      const invoice = this.getInvoiceRawRecord(item);
      if (!invoice) {
        return;
      }
      const invoiceType = String(
        Number.isFinite(Number(invoice.invoiceType)) ? Number(invoice.invoiceType) : 0
      );
      this.invoiceApplyForm.invoiceType = invoiceType;
      if (invoiceType === "0") {
        this.invoiceApplyForm.invoiceHeader = invoice.companyName || "";
        this.invoiceApplyForm.taxNo = invoice.dutyParagraph || "";
      } else {
        this.invoiceApplyForm.invoiceHeader = invoice.personName || "个人";
      }
      this.invoiceApplyForm.email = invoice.email || "";
      this.invoiceApplyForm.address = invoice.address || "";
      this.invoiceApplyForm.telephone = invoice.phone || "";
      this.invoiceApplyForm.bankName = invoice.bankName || "";
      this.invoiceApplyForm.bankNo = invoice.bankAccount || "";
    },
    async ensureInvoiceContentLoaded() {
      if (this.invoiceContent && String(this.invoiceContent).trim()) {
        return;
      }
      try {
        const res = await httpRequest("/app/setting/info", "get", null);
        if (res && res.code === 200 && res.data) {
          this.invoiceContent = `*${res.data.goodsTaxName || ""}*${res.data.caption || ""}`;
        }
      } catch (error) {
        void error;
      }
    },
    handleInvoiceTypeChange() {
      if (this.invoiceApplyForm.invoiceType === "1") {
        this.invoiceApplyForm.invoiceHeader = "个人";
      } else {
        this.invoiceApplyForm.invoiceHeader = "";
      }
    },
    async openApplyInvoiceDialog(item) {
      if (!item || !Number.isFinite(Number(item.arId))) {
        this.$message.warning("报名信息异常");
        return;
      }
      this.invoiceApplyTarget = item;
      this.fillInvoiceApplyFormByRecord(item);
      await this.ensureInvoiceContentLoaded();
      this.invoiceApplyDialogVisible = true;
    },
    openInvoiceDetailDialog(item) {
      const invoice = this.getInvoiceRawRecord(item);
      if (!invoice) {
        this.$message.warning("暂无发票详情");
        return;
      }
      this.invoiceDetailRecord = { ...invoice };
      this.invoiceDetailDialogVisible = true;
    },
    async submitInvoiceApply() {
      if (this.invoiceApplying) {
        return;
      }
      const target = this.invoiceApplyTarget;
      if (!target || !Number.isFinite(Number(target.arId))) {
        this.$message.error("开票信息异常，请重试");
        return;
      }
      if (!String(this.invoiceApplyForm.invoiceHeader || "").trim()) {
        this.$alert(
          "请填写" +
            (this.invoiceApplyForm.invoiceType === "0" ? "单位名称" : "个人名称"),
          "警告"
        );
        return;
      }
      if (
        this.invoiceApplyForm.invoiceType === "0" &&
        !String(this.invoiceApplyForm.taxNo || "").trim()
      ) {
        this.$alert("请填写纳税人识别号", "警告");
        return;
      }
      if (!String(this.invoiceApplyForm.email || "").trim()) {
        this.$alert("请填写收票人邮箱", "警告");
        return;
      }
      this.invoiceApplying = true;
      const params = {
        arId: Number(target.arId),
        invoiceType: this.invoiceApplyForm.invoiceType,
        personName: this.invoiceApplyForm.invoiceHeader,
        companyName: this.invoiceApplyForm.invoiceHeader,
        dutyParagraph: this.invoiceApplyForm.taxNo,
        address: this.invoiceApplyForm.address,
        phone: this.invoiceApplyForm.telephone,
        bankName: this.invoiceApplyForm.bankName,
        bankAccount: this.invoiceApplyForm.bankNo,
        money: this.invoiceApplyPrice,
        email: this.invoiceApplyForm.email
      };
      try {
        const res = await httpRequest("/app/invoice/invoice", "post", params);
        if (!(res && res.code === 200)) {
          this.$message.error((res && res.message) || "提交失败，请稍后重试");
          return;
        }
        this.invoiceApplyDialogVisible = false;
        await this.$alert(
          "提交成功，发票将在5分钟内送至您的邮箱，请及时查收",
          "提示",
          {
            showClose: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            closeOnHashChange: false
          }
        );
        await this.loadInvoiceRecords();
      } catch (error) {
        void error;
        this.$message.error("提交失败，请稍后重试");
      } finally {
        this.invoiceApplying = false;
      }
    },
    async downloadInvoicePdf(url) {
      if (!url) {
        this.$message.warning("发票文件不存在");
        return;
      }
      const safeUrl = String(url).trim();
      if (!safeUrl) {
        this.$message.warning("发票文件不存在");
        return;
      }
      window.open(safeUrl, "_blank");
    },
    handleInvoiceAction(item) {
      const action = this.getInvoiceAction(item);
      if (!action || !item) {
        return;
      }
      if (action.type === "APPLY") {
        this.openApplyInvoiceDialog(item);
        return;
      }
      if (action.type === "DOWNLOAD") {
        const invoice = this.getInvoiceRawRecord(item);
        const pdf = invoice ? invoice.pdf : "";
        if (pdf) {
          this.downloadInvoicePdf(pdf);
          return;
        }
      }
      const invoice = this.getInvoiceRawRecord(item);
      if (!invoice) {
        this.$message.warning("暂无发票详情");
        return;
      }
      this.openInvoiceDetailDialog(item);
    },
    normalizeNeedLearnHours(item) {
      const need = Number(item && item.apply && item.apply.needLearnDuration);
      const done = Number(item && item.apply && item.apply.yetLearnDuration);
      if (!Number.isFinite(need) || need <= 0) {
        return "0.00";
      }
      const doneValue = Number.isFinite(done) ? done : 0;
      const remain = Math.max(0, need - doneValue);
      return (remain / 60 / 45).toFixed(2);
    },
    getFlowStatusValue(item) {
      return Number(item && item.flowStatus && item.flowStatus.status);
    },
    getPaperStatusValue(item) {
      return Number(item && item.flowStatus && item.flowStatus.paperStatus);
    },
    getExamTypeValue(item) {
      return Number(item && item.apply && item.apply.examType);
    },
    getMajorTypeValue(item) {
      return Number(item && item.majorType);
    },
    isFirstExam(item) {
      const examType = this.getExamTypeValue(item);
      return !Number.isFinite(examType) || examType === 0;
    },
    getTrainStatusText(item) {
      if (!item || !item.apply || !item.flowStatus) {
        return STATUS_UNKNOWN;
      }
      const status = this.getFlowStatusValue(item);
      const majorType = this.getMajorTypeValue(item);
      const remainLearnHours = this.normalizeNeedLearnHours(item);
      const remainText = `还需${remainLearnHours}学时开放考试`;

      if (majorType === 1) {
        switch (status) {
          case 0:
            return remainText;
          case 1:
            return "考试进行中";
          case 2:
            return "很遗憾，您未通过考试，请重新考试";
          case 3:
          case 13:
            return "理论考试未通过，培训结束";
          case 5:
            return "理论考试已通过，请进行实践考核";
          case 6:
            return "实践考核中";
          case 7:
            return "考核未通过，培训结束";
          case 15:
            return "暂未到学习时间";
          case 17:
            return "查看证书";
          default:
            return STATUS_UNKNOWN;
        }
      }

      if (this.isFirstExam(item)) {
        switch (status) {
          case 0:
            return remainText;
          case 1:
            return "考试进行中";
          case 2:
            return "很遗憾，您未通过考试，请重新考试";
          case 3:
          case 13:
            return "理论考试未通过，培训结束";
          case 4:
            return "理论考试通过";
          case 5:
          case 44:
            return "实习单位选择完成，请进行实践考核";
          case 6:
            return "实践考核中";
          case 7:
            return "考核未通过，培训结束";
          case 8:
            return "考核通过";
          case 9:
            return "论文待审核";
          case 10:
            return "论文审核失败，请重新上传";
          case 11:
            return "论文审核成功，查看证书";
          case 12:
            return "论文审核未通过，培训结束";
          case 14:
            return "实习单位未选择，培训结束";
          case 15:
            return "暂未到学习时间";
          case 17:
            return "查看证书";
          case 19:
            return "培训时间已到，论文审核未通过";
          default:
            return STATUS_UNKNOWN;
        }
      }

      switch (status) {
        case 0:
          return remainText;
        case 1:
          return "考试进行中";
        case 2:
          return "很遗憾，您未通过考试，请重新考试";
        case 3:
        case 13:
          return "理论考试未通过，培训结束";
        case 4:
          return "理论考试通过";
        case 15:
          return "暂未到学习时间";
        case 17:
          return "查看证书";
        default:
          return STATUS_UNKNOWN;
      }
    },
    buildRecordAction(label, type, options = {}) {
      return {
        label,
        type,
        primary: options.primary === true,
        disabled: options.disabled === true
      };
    },
    getRecordActions(item) {
      if (!item || !item.flowStatus || !item.apply) {
        return [];
      }
      const status = this.getFlowStatusValue(item);
      const paperStatus = this.getPaperStatusValue(item);
      const isFirstExam = this.isFirstExam(item);
      const apply = item.apply || {};
      const paperUrl =
        typeof apply.paperUrl === "string" ? apply.paperUrl.trim() : "";
      const isCheckPass = Number(apply.isCheckPass);

      if (status === 17) {
        return [this.buildRecordAction("下载证书", "CERT", { primary: true })];
      }
      if (status === 11) {
        return [this.buildRecordAction("下载证书", "CERT", { primary: true })];
      }
      if (status === 10) {
        return [this.buildRecordAction("重新上传", "UPLOAD_PAPER", { primary: true })];
      }
      if (status === 9) {
        return [this.buildRecordAction("审核中", "NONE", { disabled: true })];
      }
      if (status === 8 && isFirstExam) {
        if (paperStatus === 11 || isCheckPass === 2) {
          return [this.buildRecordAction("下载证书", "CERT", { primary: true })];
        }
        if (paperStatus === 10 || isCheckPass === 1) {
          return [this.buildRecordAction("重新上传", "UPLOAD_PAPER", { primary: true })];
        }
        if (paperStatus === 9 || (paperUrl && isCheckPass === 0)) {
          return [this.buildRecordAction("审核中", "NONE", { disabled: true })];
        }
        return [
          this.buildRecordAction("上传论文（支持word、PDF格式）", "UPLOAD_PAPER", {
            primary: true
          })
        ];
      }
      if (status === 2) {
        return [this.buildRecordAction("重新考试", "EXAM", { primary: true })];
      }
      if (status === 1) {
        return [
          this.buildRecordAction("学时已满 可以进行考试", "EXAM", {
            primary: true
          })
        ];
      }
      if (status === 0) {
        return [this.buildRecordAction("已报名学时未满", "STUDY", { primary: true })];
      }
      if (status === 15) {
        return [
          this.buildRecordAction("理论学习未开始", "STUDY", { primary: true })
        ];
      }
      if (status === 4 && isFirstExam) {
        return [
          this.buildRecordAction("请前往选择实习单位", "CHOOSE_BASE", {
            primary: true
          })
        ];
      }
      if (status === 5 || status === 6 || status === 44) {
        return [
          this.buildRecordAction(
            status === 6 ? "实践考核中" : "请前往主页进行实践考核",
            "PRACTICE",
            {
              primary: true
            }
          )
        ];
      }
      return [];
    },
    normalizeCertificateUrl(url) {
      if (url === null || url === undefined) {
        return "";
      }
      const text = String(url).trim();
      return text || "";
    },
    isPdfUrl(url) {
      if (!url) {
        return false;
      }
      return /\.pdf(\?|$)/i.test(String(url));
    },
    resolveTrainCertificateUrl(item) {
      const apply = (item && item.apply) || {};
      const certificate = apply.certificate || {};
      const candidates = [
        item && item.certificateUrl,
        item && item.certificate_url,
        apply.certificateUrl,
        apply.certificate_url,
        certificate.certificateUrl,
        certificate.certificate_url
      ];
      for (let i = 0; i < candidates.length; i += 1) {
        const url = this.normalizeCertificateUrl(candidates[i]);
        if (url) {
          return url;
        }
      }
      return "";
    },
    resolveLatestFormalTestId(item) {
      if (!item || !Array.isArray(item.formals) || item.formals.length === 0) {
        return null;
      }
      const sorted = item.formals.slice().sort((a, b) => {
        const sortA = Number(a && a.sort);
        const sortB = Number(b && b.sort);
        if (sortA !== sortB) {
          return sortB - sortA;
        }
        return Number(b && b.ftId) - Number(a && a.ftId);
      });
      const ftId = Number(sorted[0] && sorted[0].ftId);
      if (!Number.isFinite(ftId) || ftId <= 0) {
        return null;
      }
      return ftId;
    },
    async fetchTrainCertificateUrlByApply(item) {
      const ftId = this.resolveLatestFormalTestId(item);
      if (!ftId) {
        return "";
      }
      try {
        const res = await httpRequest("/app/exam/apply", "get", { ftId });
        if (!(res && res.code === 200 && res.data)) {
          return "";
        }
        return this.normalizeCertificateUrl(
          res.data.certificateUrl || res.data.certificate_url
        );
      } catch (error) {
        void error;
        return "";
      }
    },
    async openCertificateDialog(item) {
      if (!item) {
        return;
      }
      this.selectedRecordForAction = item;
      this.certificateLoading = true;
      this.certDialogVisible = true;
      try {
        let certificateUrl = this.resolveTrainCertificateUrl(item);
        if (!certificateUrl) {
          certificateUrl = await this.fetchTrainCertificateUrlByApply(item);
        }
        this.certPreviewUrl = certificateUrl;
        if (!certificateUrl) {
          this.$message.warning("暂无证书");
        }
      } finally {
        this.certificateLoading = false;
      }
    },
    async downloadCertificate() {
      if (!this.certPreviewUrl || this.downloadingCert) {
        return;
      }
      this.downloadingCert = true;
      try {
        const response = await fetch(this.certPreviewUrl);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const blob = await response.blob();
        const extMatch = this.certPreviewUrl.match(/\.(jpg|png|jpeg|pdf)(\?|$)/i);
        const ext = extMatch ? extMatch[1].toLowerCase() : "png";
        const userName = this.userInfo.realName || this.userInfo.phone || "";
        const examName =
          (this.selectedRecordForAction && this.selectedRecordForAction.name) ||
          "";
        const defaultName =
          "培训合格证书" +
          (userName ? `_${userName}` : "") +
          (examName ? `_${examName}` : "") +
          `.${ext}`;

        if (window.showSaveFilePicker) {
          try {
            const mimeMap = {
              png: "image/png",
              jpg: "image/jpeg",
              jpeg: "image/jpeg",
              pdf: "application/pdf"
            };
            const handle = await window.showSaveFilePicker({
              suggestedName: defaultName,
              types: [
                {
                  description: "证书文件",
                  accept: { [mimeMap[ext] || "image/png"]: [`.${ext}`] }
                }
              ]
            });
            const writable = await handle.createWritable();
            await writable.write(blob);
            await writable.close();
            this.$message.success("证书已保存");
            return;
          } catch (pickerErr) {
            if (pickerErr && pickerErr.name === "AbortError") {
              return;
            }
          }
        }

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = defaultName;
        document.body.appendChild(link);
        link.click();
        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }, 100);
      } catch (error) {
        void error;
        this.$message.error("下载证书失败，请稍后重试");
      } finally {
        this.downloadingCert = false;
      }
    },
    openPaperUploadDialog(item) {
      if (!item) {
        return;
      }
      const ftId = this.resolveLatestFormalTestId(item);
      if (!ftId) {
        this.$message.warning("考试记录异常，无法上传论文");
        return;
      }
      this.selectedRecordForAction = item;
      this.paperUploadFileName =
        (item.apply && item.apply.paperName) || "未上传";
      this.paperUploadDialogVisible = true;
    },
    async handlePaperUploadFile(params) {
      const item = this.selectedRecordForAction;
      const ftId = this.resolveLatestFormalTestId(item);
      if (!item || !ftId || !params || !params.file) {
        if (params && params.onError) {
          params.onError(new Error("UPLOAD_PARAM_INVALID"));
        }
        return;
      }
      if (this.uploadingPaper) {
        return;
      }
      this.uploadingPaper = true;
      this.paperUploadFileName = params.file.name;
      const formData = new FormData();
      formData.append("officeFile", params.file);
      try {
        const fileRes = await httpRequest(
          this.paperUploadAction,
          "post",
          formData
        );
        if (
          !(
            fileRes &&
            fileRes.code === 200 &&
            Array.isArray(fileRes.data) &&
            fileRes.data[0]
          )
        ) {
          this.$message.error("论文文件上传失败，请重试");
          if (params.onError) {
            params.onError(new Error("UPLOAD_FILE_FAILED"));
          }
          return;
        }
        const saveRes = await httpRequest("/app/exam/apply/upload-paper", "put", {
          paperUrl: fileRes.data[0],
          paperName: params.file.name,
          ftId
        });
        if (!(saveRes && saveRes.code === 200)) {
          this.$message.error("论文上传失败，请稍后重试");
          if (params.onError) {
            params.onError(new Error("SAVE_PAPER_FAILED"));
          }
          return;
        }
        this.paperUploadDialogVisible = false;
        this.$message.success("论文上传成功，请等待审核");
        await this.loadTrainingRecords();
        if (params.onSuccess) {
          params.onSuccess(saveRes, params.file);
        }
      } catch (error) {
        void error;
        this.$message.error("论文上传失败，请稍后重试");
        if (params.onError) {
          params.onError(error);
        }
      } finally {
        this.uploadingPaper = false;
      }
    },
    handleRecordAction(action, item) {
      if (!action || action.disabled || !item) {
        return;
      }
      const erId = Number(item.erId);
      const arId = Number(item.apply && item.apply.arId);
      const majorId = Number(item.majorId);
      switch (action.type) {
        case "STUDY":
          if (Number.isFinite(erId) && erId > 0) {
            this.$router.push({
              path: "/studyPage",
              query: {
                erId: String(erId)
              }
            });
          } else {
            this.$router.push("/studyPage");
          }
          return;
        case "EXAM":
          if (!Number.isFinite(erId) || erId <= 0) {
            this.$message.warning("考试信息异常");
            return;
          }
          this.$router.push({
            path: "/examInfo",
            query: {
              erId: String(erId)
            }
          });
          return;
        case "CHOOSE_BASE": {
          if (!Number.isFinite(arId) || arId <= 0) {
            this.$message.warning("报名信息异常");
            return;
          }
          const query = {
            arId: String(arId)
          };
          if (Number.isFinite(majorId) && majorId > 0) {
            query.majorId = String(majorId);
          }
          this.$router.push({
            path: "/choicePracticeBase",
            query
          });
          return;
        }
        case "PRACTICE":
          if (!Number.isFinite(erId) || erId <= 0) {
            this.$message.warning("实践考核信息异常");
            return;
          }
          this.$router.push({
            path: "/expert",
            query: {
              erId: String(erId)
            }
          });
          return;
        case "CERT":
          this.openCertificateDialog(item);
          return;
        case "UPLOAD_PAPER":
          this.openPaperUploadDialog(item);
          return;
        default:
      }
    },
    async loadUserInfo() {
      try {
        const res = await httpRequest("/app/user", "get", null);
        if (res && res.code === 200) {
          this.userInfo = res.data || {};
          localStorage.setItem("pc_user", JSON.stringify(this.userInfo));
          if (this.activeMenu === "transfer") {
            const authStatus = Number(this.userInfo.authStatus);
            if (authStatus === 2) {
              this.loadTransferMajorList();
            } else {
              this.transferMajorList = [];
            }
          }
        }
      } catch (error) {
        console.error("加载用户信息失败:", error);
      } finally {
        this.userInfoLoaded = true;
      }
    },
    async loadUnreadCount() {
      try {
        let res = await httpRequest("/app/message/getUnreadCount", "get", {});
        if (!res || res.code !== 200) {
          // 兼容老版本后端接口
          res = await httpRequest("/app/message/browse", "get", null);
        }
        if (res && res.code === 200) {
          this.unreadCount = this.normalizeUnreadCount(res.data);
        }
      } catch (error) {
        console.error("加载未读消息数量失败:", error);
      }
    },
    async loadTrainingRecords() {
      this.loading = true;
      try {
        const res = await httpRequest("/app/exam/exam/trains", "get", null);
        if (res && res.code === 200) {
          this.trainingRecords = this.normalizeTrainingList(res.data);
          this.recordPageNo = 1;
        } else {
          this.trainingRecords = [];
          this.recordPageNo = 1;
        }
      } catch (error) {
        console.error("加载培训记录失败:", error);
        this.trainingRecords = [];
        this.recordPageNo = 1;
      } finally {
        this.loading = false;
      }
    },
    async loadInvoiceRecords() {
      this.loadingInvoiceRecords = true;
      try {
        const res = await httpRequest("/app/invoice/invoice/invoices", "get", null);
        if (res && res.code === 200) {
          const list = this.normalizeInvoiceList(res.data);
          this.invoiceRecords = list
            .slice()
            .sort((a, b) => this.getInvoiceTimeForSort(b) - this.getInvoiceTimeForSort(a));
          this.invoicePageNo = 1;
        } else {
          this.invoiceRecords = [];
          this.invoicePageNo = 1;
        }
      } catch (error) {
        console.error("加载发票列表失败:", error);
        this.invoiceRecords = [];
        this.invoicePageNo = 1;
      } finally {
        this.loadingInvoiceRecords = false;
      }
    },
    async loadPaymentRecords() {
      this.loadingPaymentRecords = true;
      try {
        const res = await httpRequest("/app/exam/apply/pays", "get", null);
        if (res && res.code === 200) {
          const list = this.normalizePaymentList(res.data);
          this.paymentRecords = list
            .slice()
            .sort((a, b) => this.getPaymentTimeForSort(b) - this.getPaymentTimeForSort(a));
          this.paymentPageNo = 1;
        } else {
          this.paymentRecords = [];
          this.paymentPageNo = 1;
        }
      } catch (error) {
        console.error("加载缴费记录失败:", error);
        this.paymentRecords = [];
        this.paymentPageNo = 1;
      } finally {
        this.loadingPaymentRecords = false;
      }
    },
    async loadMessages() {
      this.loading = true;
      try {
        let res = await httpRequest(`/app/message?currentPage=${this.messagePageNo}&pageSize=${this.messagePageSize}`, "get", null);
        if (res && res.code === 200) {
          this.messages = this.normalizeMessageList(res.data.list || res.data);
          this.messageTotalCount = res.data.totalRecord || (Array.isArray(res.data) ? res.data.length : 0);
        }
      } catch (error) {
        console.error("加载消息列表失败:", error);
      } finally {
        this.loading = false;
      }
    },
    handleMessagePageChange(pageNo) {
      this.messagePageNo = pageNo;
      this.loadMessages();
    },
    handleMessagePageSizeChange(pageSize) {
      this.messagePageSize = pageSize;
      this.messagePageNo = 1;
      this.loadMessages();
    },
    async handleViewMessage(msg) {
      this.currentMessageTitle = msg.title || '消息详情';
      this.currentMessageContent = '';
      this.messageDialogVisible = true;
      this.checkingMessage = true;
      
      try {
        const msgId = msg.umId || msg.id;
        const res = await httpRequest(`/app/message/${msgId}`, 'get', null);
        if (res && res.code === 200 && res.data) {
          this.currentMessageContent = res.data.content || '无内容';
          if (!msg.isRead) {
            msg.isRead = true;
            msg.isBrowse = 1;
            this.loadUnreadCount();
          }
        } else {
          this.$message.error('无法获取消息详情');
          this.currentMessageContent = '加载失败';
        }
      } catch (error) {
        console.error('获取消息详情失败:', error);
        this.currentMessageContent = '加载失败';
      } finally {
        this.checkingMessage = false;
      }
    },
    async handleReadAllMessages() {
      try {
        await this.$confirm('确定要将所有消息标记为已读吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        });
      } catch {
        return; // 用户取消
      }
      this.markingAllRead = true;
      try {
        const res = await httpRequest('/app/message/readAll', 'get', null);
        if (res && res.code === 200) {
          this.$message.success('已全部标记为已读');
          this.messagePageNo = 1;
          this.loadMessages();
          this.loadUnreadCount();
        } else {
          this.$message.error(res.msg || '操作失败');
        }
      } catch (error) {
        console.error('标记全部已读失败:', error);
        this.$message.error('操作失败');
      } finally {
        this.markingAllRead = false;
      }
    },
    handleMenuSelect(index) {
      this.activeMenu = index;

      // 跳转到对应页面
      if (index === "realName") {
        this.$router.push("/realName");
        return;
      }

      // 加载对应数据
      if (index === "records") {
        this.loadTrainingRecords();
      } else if (index === "invoice") {
        this.loadInvoiceRecords();
      } else if (index === "payment") {
        this.loadPaymentRecords();
      } else if (index === "collection") {
        this.loadCollectionData();
      } else if (index === "messages") {
        this.loadMessages();
      } else if (index === "transfer") {
        this.resetTransferForm();
        this.loadTransferMajorList();
      }
    },
    handleLogout() {
      this.$confirm("确定要退出登录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          localStorage.removeItem("pc_user_token");
          localStorage.removeItem("pc_user");
          this.$router.replace("/login");
          this.$message.success("已退出登录");
        })
        .catch(() => {
          // keep logging out cancelled
        });
    }
  }
};
</script>

<style scoped>
.mine-container {
  max-width: 1360px;
  margin: 0 auto;
  padding: 20px;
}

.mine-wrapper {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

.sidebar {
  width: 260px;
  min-width: 260px;
  flex: 0 0 260px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.user-info {
  padding: 30px 20px 20px;
  text-align: center;
  border-bottom: 12px solid #f5f7fa;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.avatar {
  position: relative;
  width: 80px;
  height: 80px;
  margin-bottom: 16px;
}

.avatar-img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  border: 4px solid #f0f4f8;
}

.auth-icon {
  position: absolute;
  bottom: 0px;
  right: 0px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: white;
  padding: 2px;
}

.user-name {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
  word-break: break-all;
  min-height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.logout-btn {
  width: 100%;
  background-color: #F05050 !important;
  border-color: #F05050 !important;
  color: #ffffff !important;
  font-size: 16px;
  font-weight: 500;
  padding: 12px 0;
  border-radius: 4px;
  transition: opacity 0.2s;
}

.logout-btn:hover {
  opacity: 0.9;
}

.sidebar-menu {
  border-right: none;
  padding: 10px 0;
}

.sidebar-menu /deep/ .el-menu-item {
  display: flex;
  align-items: center;
  height: 56px;
  line-height: 56px;
  padding: 0 24px !important;
  font-size: 15px;
  color: #333;
}

.sidebar-menu /deep/ .el-menu-item i {
  font-size: 18px;
  margin-right: 12px;
  color: #909399;
}

.sidebar-menu /deep/ .el-menu-item.is-active {
  background-color: #f0f7ff;
  color: #1e87f0;
  font-weight: 500;
}

.sidebar-menu /deep/ .el-menu-item.is-active i {
  color: #1e87f0;
}

.badge {
  margin-left: auto;
  color: #F05050;
  font-size: 14px;
  font-weight: 500;
}

.auth-text {
  margin-left: auto;
  font-size: 14px;
  font-weight: 500;
}

.main-content {
  flex: 1 1 auto;
  min-width: 0;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.04);
  border: 1px solid #ebeef5;
  padding: 60px 40px;
  min-height: 600px;
  display: flex;
  flex-direction: column;
}

.main-top-title {
  font-size: 26px;
  font-weight: 500;
  color: #1a73e8; /* slightly deeper blue */
  text-align: center;
  margin-bottom: 24px;
  letter-spacing: 1px;
}

.profile-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 0;
}

.profile-action-center {
  margin-top: 10px;
  margin-bottom: 10px;
}

.centered-info-list {
  display: flex;
  flex-direction: column;
  width: 480px; 
  background: #f8f9fc; /* Very light modern gray-blue background */
  border-radius: 12px;
  padding: 10px 40px;
  margin-top: 130px;
}

.info-row {
  display: flex;
  align-items: center;
  padding: 24px 0;
  border-bottom: 1px solid #eef0f6;
}

.info-row:last-child {
  border-bottom: none;
}

.info-row .label {
  width: 80px;
  font-size: 15px;
  color: #8c939d;
  margin-right: 24px;
}

.info-row .value {
  font-size: 16px;
  font-weight: 500;
  color: #303133;
  flex: 1;
}

.auth-btn {
  width: 140px;
  height: 38px;
  border-radius: 4px;
  font-size: 15px;
  font-weight: 500;
  background: transparent;
  padding: 0;
}

.btn-unauth {
  color: #15b392;
  border: 1px solid #15b392;
}

.btn-unauth:hover {
  background: rgba(21, 179, 146, 0.05);
}

.btn-auditing {
  color: #e6a23c !important; /* Element UI standard warning color */
  border: 1px solid #e6a23c !important;
  background: transparent !important;
  cursor: not-allowed;
}

.btn-rejected {
  width: 200px;
  color: #f56c6c;
  border: 1px solid #f56c6c;
}

.btn-rejected:hover {
  background: rgba(245, 108, 108, 0.05);
}

.section-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 24px;
  padding-bottom: 12px;
  border-bottom: 2px solid #409eff;
}

.profile-form {
  max-width: 500px;
}

.records-section {
  display: flex;
  flex-direction: column;
  margin-top: 60px; /* Align vertical visually with the left 'Profile Menu' item */
}

.invoice-section {
  display: flex;
  flex-direction: column;
  margin-top: 60px;
}

.payment-section {
  display: flex;
  flex-direction: column;
  margin-top: 60px;
}

.collection-section {
  display: flex;
  flex-direction: column;
  margin-top: 60px;
}

.transfer-section {
  display: flex;
  flex-direction: column;
  margin-top: 60px;
}

.transfer-wrapper {
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #ebeef5;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.04);
  padding: 30px 36px 36px;
}

.transfer-auth-tip {
  text-align: center;
  font-size: 24px;
  font-weight: 500;
  color: #303133;
  padding: 100px 0;
}

.transfer-form {
  width: 100%;
  max-width: 980px;
  margin: 0 auto;
}

.transfer-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 18px;
}

.transfer-row-upload {
  margin-top: 6px;
  margin-bottom: 30px;
}

.transfer-label {
  width: 230px;
  min-width: 230px;
  line-height: 40px;
  font-size: 16px;
  color: #303133;
  text-align: right;
  padding-right: 18px;
}

.transfer-field {
  flex: 1;
  min-width: 0;
}

.transfer-field ::v-deep .el-select {
  width: 100%;
}

.transfer-field ::v-deep .el-input__inner {
  height: 40px;
  line-height: 40px;
  font-size: 14px;
}

.required {
  color: #f56c6c;
  margin-right: 4px;
}

.transfer-hospital-tip {
  text-align: left;
  margin-top: 8px;
  font-size: 15px;
  color: #606266;
  line-height: 1.5;
}

.transfer-hospital-phone {
  color: #f05050;
}

.transfer-license-upload {
  width: 120px;
  height: 120px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  cursor: pointer;
  overflow: hidden;
  background: #fafafa;
}

.transfer-license-upload ::v-deep .el-upload {
  width: 100%;
  height: 100%;
}

.transfer-license-preview,
.transfer-license-placeholder {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.transfer-action {
  display: flex;
  justify-content: center;
  margin-top: 24px;
}

.transfer-submit-btn {
  width: 380px;
  height: 46px;
  border-radius: 4px;
  font-size: 20px;
  padding: 0;
}

.training-record-wrapper {
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #ebeef5;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.04);
  padding: 24px;
}

.invoice-wrapper {
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #ebeef5;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.04);
  padding: 24px;
}

.payment-wrapper {
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #ebeef5;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.04);
  padding: 24px;
}

.collection-wrapper {
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);
  padding: 24px;
  min-height: 420px;
}

.collection-tabs {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 40px;
  margin-bottom: 24px;
  border-bottom: 1px solid #e2e8f0;
  padding: 0 12px;
}

.collection-tab {
  font-size: 16px;
  font-weight: 500;
  color: #64748b;
  padding: 12px 4px;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
  bottom: -1px;
}

.collection-tab:hover {
  color: #0ea5e9;
}

.collection-tab-active {
  color: #0ea5e9;
  border-bottom-color: #0ea5e9;
}

.collection-empty {
  min-height: 280px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.collection-empty img {
  width: 120px;
  height: 120px;
  object-fit: contain;
}

.collection-empty-text {
  margin-top: 16px;
  font-size: 14px;
  color: #94a3b8;
}

.training-record-table {
  width: 100%;
}

.invoice-record-table {
  width: 100%;
}

.payment-record-table {
  width: 100%;
}

.collection-record-table {
  width: 100%;
}

.training-record-table ::v-deep .el-table__header-wrapper th {
  background: #f8f9fc;
  color: #606266;
  font-weight: 600;
  padding: 14px 0;
  border-bottom: 2px solid #ebeef5;
}

.invoice-record-table ::v-deep .el-table__header-wrapper th {
  background: #f8f9fc;
  color: #606266;
  font-weight: 600;
  padding: 14px 0;
  border-bottom: 2px solid #ebeef5;
}

.payment-record-table ::v-deep .el-table__header-wrapper th {
  background: #f8f9fc;
  color: #606266;
  font-weight: 600;
  padding: 14px 0;
  border-bottom: 2px solid #ebeef5;
}

.collection-record-table ::v-deep .el-table__header-wrapper th {
  background: #f8f9fc;
  color: #606266;
  font-weight: 600;
  padding: 14px 0;
  border-bottom: 2px solid #ebeef5;
}

.training-record-table ::v-deep .el-table td,
.training-record-table ::v-deep .el-table th {
  padding: 12px 0;
}

.invoice-record-table ::v-deep .el-table td,
.invoice-record-table ::v-deep .el-table th {
  padding: 12px 0;
}

.payment-record-table ::v-deep .el-table td,
.payment-record-table ::v-deep .el-table th {
  padding: 12px 0;
}

.collection-record-table ::v-deep .el-table td,
.collection-record-table ::v-deep .el-table th {
  padding: 12px 0;
}

.training-record-table ::v-deep .el-table__body td {
  color: #303133;
  border-bottom: 1px solid #f0f2f5;
}

.invoice-record-table ::v-deep .el-table__body td {
  color: #303133;
  border-bottom: 1px solid #f0f2f5;
}

.payment-record-table ::v-deep .el-table__body td {
  color: #303133;
  border-bottom: 1px solid #f0f2f5;
}

.collection-record-table ::v-deep .el-table__body td {
  color: #303133;
  border-bottom: 1px solid #f0f2f5;
}

.collection-link-btn {
  border: none;
  background: transparent;
  color: #2f80ed;
  font-size: 14px;
  padding: 0;
  cursor: pointer;
}

.collection-link-btn + .collection-link-btn {
  margin-left: 12px;
}

.collection-link-btn-danger {
  color: #2f80ed;
}

.record-status-text {
  color: #606266;
}

.invoice-status-text {
  color: #606266;
  line-height: 1.4;
  word-break: break-all;
}

.invoice-status-success {
  color: #12a151;
}

.invoice-status-fail {
  color: #f56c6c;
}

.record-action-btn {
  margin-right: 8px;
  margin-bottom: 4px;
  border-radius: 6px;
  padding: 7px 14px;
  font-size: 13px;
  border-color: #dce6f3;
  color: #4f5f72;
  background: #f8f9fc;
  transition: all 0.2s ease;
}

.record-action-btn-primary {
  background: #1a73e8;
  border-color: #1a73e8;
  color: #ffffff;
}

.record-action-btn-primary:hover,
.record-action-btn-primary:focus {
  background: #155cb8;
  border-color: #155cb8;
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(26, 115, 232, 0.2);
}

.record-action-btn-disabled,
.record-action-btn-disabled:hover,
.record-action-btn-disabled:focus {
  background: #f2f4f7;
  border-color: #e0e4ea;
  color: #a4acb7;
}

.record-action-empty {
  color: #b2b7bf;
}

.invoice-action-btn {
  border-radius: 16px;
  padding: 7px 14px;
  font-size: 13px;
  border-color: #1a73e8;
  color: #ffffff;
  background: #1a73e8;
  transition: all 0.2s ease;
}

.invoice-action-btn:hover,
.invoice-action-btn:focus {
  background: #155cb8;
  border-color: #155cb8;
  color: #ffffff;
}

.mine-invoice-dialog ::v-deep .el-dialog__body {
  padding: 24px 32px 16px;
  background-color: #f8fafc;
}

.mine-invoice-dialog-body {
  max-height: 62vh;
  overflow: auto;
  border-radius: 8px;
  background: #ffffff;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}

.mine-invoice-form {
  text-align: left;
}

.mine-invoice-form ::v-deep .el-form-item {
  margin-bottom: 18px;
}

.mine-invoice-form ::v-deep .el-form-item:last-child {
  margin-bottom: 0;
}

.mine-invoice-form ::v-deep .el-form-item__label {
  color: #475569;
  font-weight: 500;
  padding-right: 16px;
}

.mine-invoice-form ::v-deep .el-form-item__content {
  color: #1e293b;
  font-size: 14px;
  line-height: 40px;
}

.mine-invoice-form ::v-deep .el-input__inner {
  height: 40px;
  line-height: 40px;
  border-radius: 6px;
  border: 1px solid #cbd5e1;
  transition: all 0.3s;
}

.mine-invoice-form ::v-deep .el-input__inner:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
}

/* 分隔线优化 */
.mine-invoice-form ::v-deep .el-divider--horizontal {
  margin: 32px 0 24px;
  background-color: #e2e8f0;
}

.mine-invoice-form ::v-deep .el-divider__text {
  color: #64748b;
  font-size: 13px;
  background-color: #ffffff;
  padding: 0 16px;
}

.table-pagination {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}

.table-pagination ::v-deep .el-pagination {
  font-weight: 400;
}

.upload-paper-dialog-body {
  text-align: center;
  padding: 8px 0 4px;
}

.upload-file-name {
  margin-bottom: 12px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}

.upload-paper-tip {
  margin-top: 12px;
  color: #909399;
  font-size: 13px;
}

.cert-dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 30px; /* Leave space for el-dialog close X button */
}

.cert-dialog-title {
  font-size: 18px;
  color: #1f2d3d;
  font-weight: 500;
}

.cert-preview-body {
  min-height: 360px;
  max-height: 68vh;
  overflow: auto;
  background: #f5f7fa;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.cert-preview-body img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 6px;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.15);
}

.cert-preview-pdf {
  width: 100%;
  min-height: 480px;
  border: none;
  border-radius: 6px;
  background: #fff;
}

.cert-preview-empty {
  color: #909399;
  font-size: 14px;
}

.messages-section {
  display: flex;
  flex-direction: column;
  margin-top: 60px; /* Align vertically visually with 'Personal Info' */
}

.message-wrapper {
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #ebeef5;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.04);
  padding: 30px;
}

.message-list {
  display: flex;
  flex-direction: column;
}

.message-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #409eff;
  margin-bottom: 24px;
  padding-bottom: 12px;
}

.message-item {
  padding: 24px 0;
  border-bottom: 1px solid #ebeef5;
  transition: background-color 0.2s;
  cursor: pointer;
}

.message-item:hover {
  background-color: #f8f9fc;
}

.mine-message-dialog .msg-content {
  font-size: 14px;
  color: #606266;
  line-height: 1.6;
  max-height: 50vh;
  overflow-y: auto;
}

.message-item:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.message-item:first-child {
  padding-top: 8px; /* Offset spacing to sit cleanly below title */
}

.msg-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.msg-title {
  font-size: 16px;
  font-weight: 500;
  color: #303133;
  display: flex;
  align-items: center;
}

.unread-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #f56c6c; /* Element UI standard danger color */
  margin-right: 8px;
  flex-shrink: 0;
}

.msg-time {
  font-size: 14px;
  color: #909399;
  flex-shrink: 0;
  margin-left: 16px;
}

.msg-content {
  font-size: 14px;
  color: #606266;
  line-height: 1.6;
}

/* Restrict any potential wildly sized rich-text coming from backend */
.msg-content ::v-deep p {
  margin: 0;
  padding: 0;
}

.msg-content ::v-deep img {
  max-width: 100%;
  height: auto;
  border-radius: 4px;
  margin-top: 8px;
}

.empty-tip {
  text-align: center;
  padding: 60px 0;
  color: #909399;
  font-size: 14px;
}

@media (max-width: 1200px) {
  .transfer-label {
    width: 180px;
    min-width: 180px;
  }
}
</style>
